import * as React from "react";

import { EnquiryContext } from "./context/EnquiryState";

type ImageDetailObject = {
	url: string,
	aspectWidth: string,
	aspectHeight: string,
	bgColor?: string,
	objectStyle?: string,
	objectPosition?: string
}

const initGeneralImgs: Array <ImageDetailObject> =[
	{
		url: "enquiry-pink-bg.png",
		aspectWidth: "aspect-w-7",
		aspectHeight: "aspect-h-10",
		objectStyle: "object-cover",
	},
	{
		url: "enquiry-orange-bg.png",
		aspectWidth: "aspect-w-6",
		aspectHeight: "aspect-h-10",
		objectStyle: "object-cover",
	},
	{
		url: "enquiry-review-step.png",
		aspectWidth: "aspect-w-5",
		aspectHeight: "aspect-h-8",
		objectStyle: "object-cover",
	}
]

const initTourImgs = [
	{
		url: "enquiry-pink-bg.png",
		aspectWidth: "aspect-w-7",
		aspectHeight: "aspect-h-10",
		objectStyle: "object-cover",
	},
	{
		url: "enquiry-green-bg.png",
		aspectWidth: "aspect-w-6",
		aspectHeight: "aspect-h-11",
		objectStyle: "object-cover",
	},
	{
		url: "enquiry-red-bg.png",
		aspectWidth: "aspect-w-6",
		aspectHeight: "aspect-h-10",
		objectStyle: "object-cover",
	},
	{
		url: "enquiry-orange-bg.png",
		aspectWidth: "aspect-w-6",
		aspectHeight: "aspect-h-10",
		objectStyle: "object-cover",
	},
	{
		url: "enquiry-review-step.png",
		aspectWidth: "aspect-w-5",
		aspectHeight: "aspect-h-10",
		objectStyle: "object-cover",
	}
]
const initPromoText = null

export const ImageComponent = (props) => {
	// These variables will be populated based on weather the promo is turned on or off via props variable, see useEffect
	const [promoText, setPromoText] = React.useState(initPromoText)
	const [generalImgs, setGeneralImgs] = React.useState(initGeneralImgs)
	const [tourImgs, setTourImgs] = React.useState(initTourImgs)

	const {
		state,
		dispatch,
	} = React.useContext(EnquiryContext)

	React.useEffect(() => {
		// If the promo flag is true
		if (props.promo) {
			// Promo text that goes over the image
			let promoCopy = <div className="absolute left-0 top-0 z-10">

				<div className="flex flex-col text-center pt-16 px-6">
					<div className="text-3xl xl:text-[40px] text-skin-heading font-extrabold leading-10 xl:leading-[3rem]">
						Complete your enquiry for the chance to<br></br>
						WIN 12 months FREE childcare, up to $10,000
					</div>
				</div>
				<div className="absolute left-0 top-60 xl:top-72">
					<img src="/img/enquiry/desktop-blue-star.png" alt="blue star" />
				</div>
				<div className="absolute bottom-20 right-0">
					<img src="/img/enquiry/desktop-blue-arch.png" alt="blue arch" />
				</div>

				{/*OLD PURPLE PROMO*/}
				{/*<div className="flex flex-col text-center pt-16 mx-8 xl:w-4/5 xl:mx-auto">*/}
				{/*	<div className="mb-2">*/}
				{/*		<span className="text-white font-bold text-4xl leading-none">Complete your enquiry for the chance to</span>*/}
				{/*	</div>*/}
				{/*	<div style={{ transform: 'rotate(1.8deg)' }}>*/}
				{/*		<span className="bg-skin-cacti rounded-xl text-skin-heading font-bold text-4xl px-3 py-1" style={{letterSpacing: '0.025em'}}>win free childcare</span>*/}
				{/*	</div>*/}
				{/*	<div className="mb-6">*/}
				{/*		<span className="text-white font-bold text-4xl">for 12 months!</span>*/}
				{/*	</div>*/}
				{/*	<div>*/}
				{/*		<span className="text-white text-sm">T&C's apply</span>*/}
				{/*	</div>*/}
				{/*</div>*/}
				{/*Corner Star*/}
				{/*<div className="absolute top-0 right-0">*/}
				{/*	<img src="/img/enquiry/desktop-corner-star.png" alt="corner star" />*/}
				{/*</div>*/}

			</div>
			setPromoText(promoCopy)

			// Images if Promo is on
			let cloneGeneralImgs = generalImgs
			cloneGeneralImgs[0] = {
				url: "promo-mama-enquiry-banner.png",
				aspectWidth: "aspect-w-7",
				aspectHeight: "aspect-h-10",
				bgColor: "bg-white", // bg-skin-eggplant",
				objectStyle: "object-cover", // object-contain",
				objectPosition: "object-bottom"
			}
			cloneGeneralImgs[1] = {
				url: "promo-mama-enquiry-banner.png",
				aspectWidth: "aspect-w-7",
				aspectHeight: "aspect-h-10",
				bgColor: "bg-white", // bg-skin-eggplant",
				objectStyle: "object-cover", // object-contain",
				objectPosition: "object-bottom"
			}
			setGeneralImgs(cloneGeneralImgs)

			//let cloneTourImgs = tourImgs

			let cloneTourImgs = tourImgs.map((step, index) => {
				if (index < tourImgs.length - 1) {

					if (index > 1) {
						step = {
							url: "promo-mama-enquiry-banner.png",
							aspectWidth: "aspect-w-7",
							aspectHeight: "aspect-h-11", // Changed for step 2 and 3 image hieght in book a tour
							objectStyle: "object-cover object-bottom",
						}
					} else {
						step = {
							url: "promo-mama-enquiry-banner.png",
							aspectWidth: "aspect-w-7",
							aspectHeight: "aspect-h-10",
							objectStyle: "object-cover object-bottom",
						}
					}
				}
				return step
			})

			setTourImgs(cloneTourImgs)
		}
	}, [])

	return (
		<React.Fragment>
			<div className={`h-auto hidden ${state.currentStep <= 1 ? "w-1/2" : "w-[45%]"} ${state.initialSelection?.id > 4 ? "" : "lg:block"}`}>
				{state.initialSelection == null &&
					<div className={`relative w-full h-full overflow-hidden ${generalImgs[0].aspectHeight} ${generalImgs[0].aspectWidth} ${generalImgs[0].bgColor}`}>
						{state.currentStep <= 1 && promoText}
						<img className={`w-full ${generalImgs[0].objectStyle} ${generalImgs[0].objectPosition}`} src={`/img/enquiry/${generalImgs[0].url}`} alt="1" />
					</div>
				}
				{state.initialSelection?.id == 1 &&
					<div className={`relative w-full h-full overflow-hidden ${generalImgs[state.currentStep].aspectHeight} ${generalImgs[state.currentStep].aspectWidth} ${generalImgs[state.currentStep].bgColor}`}>
						{state.currentStep <= 1 && promoText}
						<img className={`w-full ${generalImgs[state.currentStep].objectStyle} ${generalImgs[state.currentStep].objectPosition}`} src={`/img/enquiry/${generalImgs[state.currentStep].url}`} alt="1" />
					</div>
				}
				{state.initialSelection?.id == 4 &&
					<div className={`w-full h-full overflow-hidden ${tourImgs[state.currentStep].aspectHeight} ${tourImgs[state.currentStep].aspectWidth}`}>
						{state.currentStep < tourImgs.length - 1 && promoText}
						<img className={`w-full ${tourImgs[state.currentStep].objectStyle}`} src={`/img/enquiry/${tourImgs[state.currentStep].url}`} alt="1" />
					</div>
				}

			</div>
		</React.Fragment>
	);

}